/**
 * TabNavigation Component
 *
 * Tab navigation for switching between alerts, products, and history views.
 */

import React from 'react';
import { Tabs } from '@shopify/polaris';

import { useMonitoringTabs } from '../../../contexts/MonitoringCenterContext';

/**
 * Tab navigation
 */
export function TabNavigation() {
  const tabs = useMonitoringTabs();

  return (
    <Tabs
      tabs={tabs.tabs}
      selected={tabs.selectedTab}
      onSelect={tabs.onTabChange}
    />
  );
}
